module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi3-fc71bd1e67fc70eeecf91f554fd41b9d.jpg";